var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatFlowAttach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 7.854,
    height: 14,
    viewBox: "0 0 7.854 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1 {\r\n        clip-rule: evenodd;\r\n      }\r\n\r\n      .cls-3 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-4 {\r\n        clip-path: url(#clip-path-2);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #748a94;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-1",
    d: "M1097.854-702.85a3.924,3.924,0,0,1-3.927,3.85,3.924,3.924,0,0,1-3.927-3.85v-7.35a2.837,2.837,0,0,1,2.856-2.8,2.837,2.837,0,0,1,2.856,2.8v5.95a1.75,1.75,0,0,1-1.785,1.75,1.75,1.75,0,0,1-1.785-1.75v-5.25h1.071v5.25a.668.668,0,0,0,.714.7.668.668,0,0,0,.714-.7v-5.95a1.75,1.75,0,0,0-1.785-1.75,1.75,1.75,0,0,0-1.785,1.75v7.35a2.837,2.837,0,0,0,2.856,2.8,2.837,2.837,0,0,0,2.856-2.8v-6.65h1.071Z",
    transform: "translate(-1090 713)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-2",
    d: "M-201,0H1239V-837H-201Z",
    transform: "translate(201 837)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    className: "cls-4",
    transform: "translate(-1291 -124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-5",
    d: "M1085-718h17.854v24H1085Z",
    transform: "translate(201 837)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFlowAttach);
export default __webpack_public_path__ + "static/media/chatFlowAttach.03fff317be5c36512b1ef11432b5c55d.svg";
export { ForwardRef as ReactComponent };